import Link from "next/link";
import { JsonLd } from "@/components/custom/JsonLd";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { SITE_URL } from "@/constants/siteUrl";

interface Props {
  currentPage?: string;
  url?: string;
}

export function BlogBreadcrumb({ currentPage, url }: Props) {
  const items = [
    { position: 1, name: "Home", item: SITE_URL },
    { position: 2, name: "Blog", item: `${SITE_URL}/blog` },
    ...(currentPage ? [{ position: 3, name: currentPage, ...(url ? { item: url } : {}) }] : []),
  ];

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map(({ position, name, item }) => ({
      "@type": "ListItem",
      position,
      name,
      ...(item ? { item: { "@id": item, "@type": "WebPage" } } : {}),
    })),
  };

  return (
    <div className="p-6 max-w-site-content mx-auto">
      <JsonLd data={jsonLd} />
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link href="/">Home</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            {currentPage ? (
              <BreadcrumbLink asChild>
                <Link href="/blog">Blog</Link>
              </BreadcrumbLink>
            ) : (
              <BreadcrumbPage>Blog</BreadcrumbPage>
            )}
          </BreadcrumbItem>
          {currentPage && (
            <>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbPage>{currentPage}</BreadcrumbPage>
              </BreadcrumbItem>
            </>
          )}
        </BreadcrumbList>
      </Breadcrumb>
    </div>
  );
}
